<template>
    <el-row :gutter="20" class="sdkMenu">
        <el-col :span="24">
            <div class="productMenu">
                <ul>
                    <li><router-link @click.native="goToProductPage()" :to="{ path: ROUTING.autopaySdk.product }">{{ $t('menu.about') }}</router-link></li>
                    <li><router-link @click.native="setDocsSectionActive()" :to="{ path: ROUTING.autopaySdk.docs.main }">{{ $t('menu.documentation') }}</router-link></li>
                    <li><router-link @click.native="setDownloadSectionActive()" :to="{ path: ROUTING.autopaySdk.files.main }">{{ $t('menu.download') }}</router-link></li>
                    <li><router-link @click.native="setFaqSectionActive()" :to="{ path: ROUTING.autopaySdk.faq.main }">{{ $t('menu.faq') }}</router-link></li>
                    <li><router-link @click.native="setChangelogSectionActive()" :to="{ path: ROUTING.autopaySdk.changelog.main }">{{ $t('menu.changelog') }}</router-link></li>
                </ul>
            </div>
        </el-col>
    </el-row>
</template>

<script>
import { ROUTING } from '../../const/routing.const'
import { mapMutations } from 'vuex'
export default {
  name: 'SdkMenu',
  data () {
    return {
      ROUTING: ROUTING
    }
  },
  methods: {
    ...mapMutations([
      'setDownloadSectionActive',
      'setDownloadSectionInactive',
      'setDocsSectionActive',
      'setDocsSectionInactive',
      'setFaqSectionActive',
      'setChangelogSectionActive',
      'setChangelogSectionInactive'
    ]),
    goToProductPage () {
      this.setDownloadSectionInactive()
      this.setDocsSectionInactive()
      this.setChangelogSectionInactive()
    }
  }
}
</script>
